import * as React from 'react';

import * as styles from './formMessage.scss';
import Warning from 'components/svg/Warning';

type Props = {
    className?: string;
}

const FormMessage: React.SFC<Props> = (props) => (

    <p className={styles.formMessage + (props.className ? ' ' + props.className : '')}>
        <span className={styles.bg} />
        {props.children}
        <Warning className={styles.iconWarning} />
    </p>


);

export default FormMessage;